import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-notification-intervention-modifiee',
  templateUrl: './notification-intervention-modifiee.component.html',
  styleUrls: ['./notification-intervention-modifiee.component.scss'],
})
export class NotificationInterventionModifieeComponent implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }
}
